import React from 'react'
import { PageTitle } from '_metronic/layout/core'

import ActiveComponent from './Components/ActiveComponent'
import NumberBox from 'Presentation/Components/Statistics/NumberBox'
import MarketplaceBoughtChart from './Components/Bought/View'
import MarketplaceTotalSaleChart from './Components/TotalSale/View'
import { ClientSideTable } from 'Presentation/Components/Table'

import useViewModel from './ViewModel'

//////////
// View //
//////////

const DashboardMarketplaceView: React.FC = () => {
	const { data, TABLE_CONFIGS, currentDataType, setCurrentDataType } = useViewModel()

	return (
		<ViewPageTitle>
			<div className="row gy-5">
				<div className="col-12 col-xl-6">
					<NumberBox
						name="orderCount"
						title="จำนวนคำสั่งซื้อ"
						toolTip="orderCount"
						unit="คำสั่งซื้อ"
						unitTooltip="คำสั่งซื้อ"
						value={1131}
						valueChangePercentage={1.3}
						hideTrend
					/>
				</div>
				<div className="col-12 col-xl-6">
					<NumberBox
						name="totalSale"
						title="ยอดขายรวม"
						toolTip="totalSale"
						unit="บาท"
						unitTooltip="บาท"
						value={112000}
						valueChangePercentage={1.3}
						hideTrend
					/>
				</div>
				<div className="col-12">
					<MarketplaceBoughtChart />
				</div>
				<div className="col-12">
					<MarketplaceTotalSaleChart />
				</div>

				<div className="col-12">
					<div className="card border border-kumopack-grey-200">
						<div className="card-header mt-4">
							<div className="card-title">
								{/* Title */}
								<div>
									<h4 className="text-kumopack-grey-900 fw-bold mb-2">
										อันดับสินค้าขายดี{' '}
										<span className="badge badge-kumopack-secondary-100 text-kumopack-secondary-700 border-radius-16px fw-normal ms-2">
											Top 20 Best Sellers
										</span>
									</h4>
									<div className="text-kumopack-grey-600 fs-6">
										Show list top 20 best sellers sold in this period.
									</div>
								</div>
							</div>

							<div className="card-toolbar">
								<div className="w-fit-content">
									<div className="kumopack-button-group">
										<button
											className="btn btn-sm white-button text-kumopack-grey-700 fw-bold left"
											onClick={() => setCurrentDataType('today')}>
											{currentDataType === 'today' && <ActiveComponent />} Today
										</button>
										<button
											className="btn btn-sm white-button text-kumopack-grey-700 fw-bold middle"
											onClick={() => setCurrentDataType('thisweek')}>
											{currentDataType === 'thisweek' && <ActiveComponent />} This Week
										</button>
										<button
											className="btn btn-sm white-button text-kumopack-grey-700 fw-bold right"
											onClick={() => setCurrentDataType('thismonth')}>
											{currentDataType === 'thismonth' && <ActiveComponent />} This Month
										</button>
									</div>
								</div>
							</div>
						</div>

						<div className="card-body px-0">
							<ClientSideTable pagination items_per_page={10} columns={TABLE_CONFIGS} data={data} />
						</div>
					</div>
				</div>
			</div>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: 'Dashboards',
						path: '/dashboard',
						isActive: false,
						isSeparator: false,
						customIcon: (
							<img
								className="me-2"
								src="/media/kumopack-sidebar-icons/Dashboard.png"
								alt="Breadcrumbs Page Custom Icon"
								width={16}
								height={16}
							/>
						),
					},
					{
						title: 'Marketplace',
						path: '#',
						isActive: true,
						isSeparator: false,
					},
				]}>
				Marketplace Dashboard
			</PageTitle>

			{children}
		</>
	)
}

export default DashboardMarketplaceView
